// removed by extract-text-webpack-plugin
module.exports = {"poster-order-overview":"poster-order-overview","container":"container","order-content":"order-content","attendee-info":"attendee-info","recipient-info":"recipient-info","school-info":"school-info","radio":"radio","wechat-pay":"wechat-pay","alipay":"alipay","tix-title":"tix-title","tix-total-price":"tix-total-price","col-sm-5":"col-sm-5","tix-edit":"tix-edit"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/PosterView/OrderOverview.scss
// module id = VBZu
// module chunks = 0